import { api, ApiRes } from '@src/utils/api/client'

export interface CurrenciesResponse {
    currencies: string[]
}

export const getCurrencies = (): ApiRes<CurrenciesResponse> =>
    api.get('v2/currencies')
